/* eslint-disable camelcase */
/* eslint-disable new-cap */
import Phaser from 'phaser';
import gameData from '../gameData';
import SelectionTray from '../objects/Game/SelectionTray';
import BasicSprite from '../objects/BasicSprite';
import StarField from '../objects/StarField';
import LevelDisplay from '../objects/Game/LevelDisplay';
import ProgressMeter from '../objects/Game/ProgressMeter';
import PlayerSpaceship_Horizontal from '../objects/Game/SpaceShip_Horizontal';
import SoundButton from '../objects/SoundButton';
import MenuButton from '../objects/MenuButton';
import GameMeteor from '../objects/Game/GameMeteor';
import MenuPopup from './MenuPopup';
import InstructionsBox from '../objects/InstructionsBox';
import DoorScene from './DoorScene';
import AudioPlayer from '../library/AudioPlayer';
import ABCyaPhaser, { Audio } from '@abcya/abcya_phaser';

export default class Game extends Phaser.Scene {
  static get KEY() {return 'Game';}

  create() {
    const randBG = Math.ceil(Math.random() * 3);
    this.background = new BasicSprite(this, this.scale.width * .5, this.scale.height * .5, `bg${randBG}`);
    this.add.existing(this.background);

    this.starField = new StarField(this);
    this.add.group(this.starField);

    this.snapToDistance = 50;
    this.activeBounds = { xMin: 320, xMax: 980, yMin: 270, yMax: 700 };

    this.countBy = gameData.countBy;

    let gameSpots = [{ x: 383,y: 600 },{ x: 815,y: 328 },{ x: 512,y: 463 },{ x: 700,y: 475 },{ x: 413,y: 312 },{ x: 893,y: 476 },{ x: 912,y: 652 },{ x: 742,y: 632 },{ x: 541,y: 652 },{ x: 582,y: 302 }];
    this.meteors = [];
    gameSpots = gameSpots
      .map(a => [Math.random(), a])
      .sort((a, b) => a[0] - b[0])
      .map(a => a[1]);

    this.nextLevelToLoad = 'Game';

    this.nextNumber = this.countBy;
    this.selectionTray = new SelectionTray(this, this.countBy);

    this.levelDisplay = new LevelDisplay(this, -40, 30, this.countBy);
    this.add.existing(this.levelDisplay);

    const levels = gameData.config.showOptions ? 6 : gameData.config.levels;
    this.progressMeter = new ProgressMeter(this, levels);

    const spaceshipY = 500;
    this.ship = new PlayerSpaceship_Horizontal(this, 200, spaceshipY);
    this.add.existing(this.ship);

    this.menuButton = new MenuButton(this, 'menuButton', 'menuButton_Depressed', () => {this.eh_MenuButton_Clicked();});
    this.soundButton = new SoundButton(this);

    this.progressMeter.SetLevel(gameData.curLevel);

    for (let i = 0; i < gameSpots.length; i++) {
      const meteor = new GameMeteor(this, gameSpots[i].x, gameSpots[i].y, gameData.indexStart + ((i + 1) * this.countBy));
      this.meteors.push(meteor);
      meteor.wholeMeteor.on('dragend', () => {this.onDragEnd(meteor);});
    }

    gameData.indexStart = gameData.indexStart + (10 * gameData.countBy);

    if (!gameData.instructionsDisplayed) {
      gameData.instructionsDisplayed = true;

      AudioPlayer.PlaySound(this, AudioPlayer.sounds.DRAG_SPACE_ROCKS, false, 1, Audio.LOCALIZATION_AUDIO_SPRITE);
      this.instructions = new InstructionsBox(this, ABCyaPhaser.Localization.instance.getLocalizedString('game_instructions'));
      this.add.existing(this.instructions);

      this.instructions.Display();
    }

    this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) {
        this.input.manager.onMouseUp(event);
      }
    });
  }

  nextLevel() {
    if (this.progressMeter.LevelsLeft() <= 1) {
      this.nextLevelToLoad = 'Bonus';
    }
    else {
      gameData.curLevel++;
      this.nextLevelToLoad = Game.KEY;
    }

    this.menuButton.button.disableInteractive();
    this.soundButton.button.button.disableInteractive();
    this.progressMeter.NextLevel();
    this.ship.FlyAway();
    this.selectionTray.AnimateOut();

    this.time.addEvent({ delay: 1500, callback: () => { this.scene.get(DoorScene.KEY).changeScene(Game.KEY, this.nextLevelToLoad);} });
  }

  eh_MenuButton_Clicked() {
    AudioPlayer.PlaySound(this, AudioPlayer.sounds.CLICK);

    this.scene.run(MenuPopup.KEY, { sceneFrom: Game.KEY });
  }

  onDragEnd(meteor) {
    const selectionspot = this.selectionTray.GetSelectionSpotByNumber(meteor.Number());
    const selectionAreaPos = selectionspot.GetCoords();
    const meteorPos = meteor.GetCoords();
    const posDiff = { x: selectionAreaPos.x - meteorPos.x, y: selectionAreaPos.y - meteorPos.y };
    const distance = Math.sqrt(posDiff.x * posDiff.x + posDiff.y * posDiff.y);

    if (distance < this.snapToDistance) {
      selectionspot.SetMeteor(meteor, posDiff);
      this.nextNumber += this.countBy;
      this.checkEnd();
    }
    else if (meteorPos.x > this.activeBounds.xMax || meteorPos.x < this.activeBounds.xMin || meteorPos.y > this.activeBounds.yMax || meteorPos.y < this.activeBounds.yMin) {
      const originalPosition = meteor.originalPosition;
      meteor.MoveTo(originalPosition.x, originalPosition.y);
    }
  }

  checkEnd() {
    if (this.selectionTray.TrayFilled()) {
      this.nextLevel();
    }
  }

  update() {
    this.selectionTray.Update();
    this.ship.Update();
    if (!gameData.instructionsDisplayed)!gameData.instructionsDisplayed;
    for (let i = 0; i < this.meteors.length; i++) {
      this.meteors[i].Update();
    }
  }
}
